import { usePersistentCache } from '@kaiizen/react-persistent-cache';
import { tellOtherWindowsIdentityChanged } from './identityAcrossWindows';

/** Clears the cache for a new identity (logout, org switch, impersonation), and reloads the other browser windows into it. */
export const useClearCache = () => {
  const persistentCache = usePersistentCache();
  return async () => {
    await persistentCache.purgeAllEntries();
    tellOtherWindowsIdentityChanged();
  };
};
